//// Application Packages
import React from 'react'

//// Application Slices

//// Application Components

//// Carbon Components
import { Tooltip } from '@carbon/react'

//// Carbon Icons
import { Information } from '@carbon/icons-react'

//// Static Constants

//////// Component
const TooltipComponent = ({ text, tooltip }) => {
    //////// Hooks

    //////// State

    //////// Slices

    //// Slice Data

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    return (
        <>
            <div className="fldoh-tooltip-group">
                <span className="fldoh-tooltip-text">{text ? text : ''}</span>
                <Tooltip
                    className="fldoh-tooltip"
                    align="bottom"
                    label={tooltip ? tooltip : ''}
                    tabIndex={0}
                    triggertext=""
                >
                    <button className="tooltip-trigger" type="button">
                        <Information />
                    </button>
                </Tooltip>
            </div>
        </>
    )
}

export default TooltipComponent
